export { default as breakpoints } from './config/breakpoints.json' assert { type: 'json' };
